import { createContext, useContext } from 'react';
// Reviewer notes on individual fields (status "changes requested"). WizardPage provides { [fieldPath]: note }; Field reads it.
export const CommentsContext = createContext({});
export const commentsByPath = review => Object.fromEntries(((review && review.fieldComments) || []).map(c => [c.fieldPath, c.note]));
export const useFieldComment = path => { const m = useContext(CommentsContext); return (m && m[path]) || null; };
